/* eslint-disable */
declare let $: any

function ajaxPost<T> (url: string, postData: Record<string, any>, options?: Record<string, any>): Promise<PostResponse<T>> {
	return new Promise<PostResponse<T>>((resolve, reject) => {
		$.ajax({
			url: url,
			type: 'POST',
			data: postData,
			dataType: 'json',
			success: (data: any, textStatus: any, jqXHR: any) => {
				resolve(data)
			},
			error: (jqXHR: any, textStatus: any, errorThrown: any) => {
				reject(errorThrown)
			},
			...options
		})
	})
}

function ajaxPostBody<T> (url: string, postData: Record<string, any>, options?: Record<string, any>): Promise<PostResponse<T>> {
	return new Promise<PostResponse<T>>((resolve, reject) => {
		$.ajax({
			url: url,
			type: 'POST',
			data: postData,
			contentType: 'application/json; charset=utf-8',
			dataType: 'json',
			success: (data: any, textStatus: any, jqXHR: any) => {
				resolve(data)
			},
			error: (jqXHR: any, textStatus: any, errorThrown: any) => {
				reject(errorThrown)
			},
			...options
		})
	})
}

function getFormData(object) {
	const formData = new FormData();
	Object.keys(object).forEach(key => formData.append(key, object[key]));
	return formData;
}

/**
 * Creates a new promise that combines multiple promises into a new one that returns
 * once all given promises are settled that is resolved or rejected.
 *
 * @param promises to be combined.
 */
function createPromiseAllSettled<T>(promises: Promise<T>[]) {
	return Promise.all(promises.map(p => Promise.resolve(p).then((value) => ({
		state: 'fulfilled',
		value: value
	}), (reason) => ({
		state: 'rejected',
		reason: reason
	}))))
}

interface ResponseError {
	message: string;
}

interface Meta {
	errors?: string[];
	total?: number;
	links?: string;
}

interface PostResponse<T> {
	meta: Meta;
	data: T;
	errors?: ResponseError[];
	summary?: any;
}

export {ajaxPost, ajaxPostBody, createPromiseAllSettled, PostResponse, getFormData}
